import { staticFile } from '@common/utils'
import { refundPolicy } from '@lib/seo'
import { NextSeo } from 'next-seo'

const REFUND_POLICY_PDF_PATH = '/pdfs/codingal-trust-certificate.pdf'

const RefundPolicy = () => (
  <>
    <NextSeo {...refundPolicy} />
    <object
      data={staticFile(REFUND_POLICY_PDF_PATH)}
      type="application/pdf"
      className="h-screen w-full bg-white"
    >
      <h1 className="text-orange font-700 px-2 md:px-5 pt-3 text-lg">
        Refund Policy
      </h1>
      <p className="text-grey px-2 md:px-5 pt-3">
        Looks like your browser does not support rendering this PDF. You can
        view our{' '}
        <a
          className="text-orange font-600 hover:underline"
          href={staticFile(REFUND_POLICY_PDF_PATH)}
        >
          refund policy here
        </a>{' '}
        instead.
      </p>
    </object>
  </>
)

export default RefundPolicy
